import React from 'react';
import { Slider } from '../../../components/Slider';
import { ColorPicker } from '../../../components/ColorPicker';
import { CollapsibleSection } from '../../../components/CollapsibleSection';
import { RAW, FONT_SIZE, SPACE } from '../../../theme';
import { TabProps, SectionLabel, SelectBox, InfoText, SHAPES, FIELD_LABEL } from './shared';

export const ProjectileTab: React.FC<TabProps> = ({ ability, update }) => {
  if (!ability.projectile) return <InfoText>This ability has no projectile data.</InfoText>;
  const p = ability.projectile;
  const patchProj = (patch: any) => update({ projectile: patch });

  return (
    <>
      <SectionLabel>Shape & Size</SectionLabel>
      <div style={{ fontSize: FONT_SIZE.sm, color: FIELD_LABEL, marginBottom: SPACE.xs }}>Shape</div>
      <SelectBox value={p.shape || 'rect'} onChange={e => patchProj({ shape: e.target.value })}>
        {SHAPES.map(s => <option key={s} value={s}>{s}</option>)}
      </SelectBox>
      <Slider label="Width" value={p.width ?? 20} min={1} max={100} step={1}
        onChange={v => patchProj({ width: v })} />
      <Slider label="Height" value={p.height ?? 4} min={1} max={100} step={1}
        onChange={v => patchProj({ height: v })} />

      <SectionLabel>Appearance</SectionLabel>
      <ColorPicker label="Color" value={p.color ?? 0xFFFF00} onChange={v => patchProj({ color: v })} />
      <ColorPicker label="Stroke" value={p.strokeColor ?? 0x000000}
        onChange={v => patchProj({ strokeColor: v })} />
      <Slider label="Stroke Width" value={p.strokeWidth ?? 0} min={0} max={5} step={0.5}
        onChange={v => patchProj({ strokeWidth: v })} />

      <SectionLabel>Physics</SectionLabel>
      {typeof p.damage === 'number' ? (
        <Slider label="Base Damage" value={p.damage} min={1} max={Math.max(100, p.damage * 2)} step={1}
          onChange={v => patchProj({ damage: v })} />
      ) : (
        <div style={{ fontSize: FONT_SIZE.sm, color: RAW.gray, marginBottom: SPACE.md }}>Damage: Scaling Function</div>
      )}
      <Slider label="Speed (px/s)" value={p.speed ?? 800} min={100} max={2500} step={50}
        onChange={v => patchProj({ speed: v })} />
      <Slider label="Gravity" value={p.gravity ?? 0} min={0} max={2000} step={50}
        onChange={v => patchProj({ gravity: v })} />
      <Slider label="Lifespan (ms)" value={p.lifespan ?? 1000} min={200} max={5000} step={100}
        onChange={v => patchProj({ lifespan: v })} />
      <Slider label="Rotation Speed" value={p.rotationSpeed ?? 0} min={0} max={30} step={1}
        onChange={v => patchProj({ rotationSpeed: v })} />

      <CollapsibleSection title="Homing" badge={p.homing?.strength ? `str:${p.homing.strength}` : undefined}>
        <Slider label="Strength" value={p.homing?.strength ?? 0} min={0} max={50} step={1}
          onChange={v => patchProj({ homing: { strength: v } })} />
        <Slider label="Turn Rate (°/s)" value={p.homing?.maxTurnRate ?? 360} min={0} max={1080} step={45}
          onChange={v => patchProj({ homing: { maxTurnRate: v } })} />
        <Slider label="Delay (ms)" value={p.homing?.delay ?? 0} min={0} max={2000} step={100}
          onChange={v => patchProj({ homing: { delay: v } })} />
      </CollapsibleSection>
    </>
  );
};
